import { Card, Flex, Spin, Tag, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LeftIcon from 'src/assets/icons/left.png';
import RightIcon from 'src/assets/icons/right.png';
import Icon from 'src/components/v2/Icon';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { OfficeTicketDetailContext } from 'src/contexts/officeTicketDetail.context';
import { IConfirm } from 'src/types/hr_ticket/approval.type';
import { IHandoverTicket } from 'src/types/office_ticket/handoverTicket.type';
import { formatDate } from 'src/utils/utils';
const { Title, Text } = Typography;

// interface ConfirmEmployee extends IEmployeeShort {

// }

export default function ConfirmLogSidebar() {
  const { t } = useTranslation();
  const { isDetailSidebarCollapsed, isTicketDetailCollapsed, setIsDetailSidebarCollapsed } = useContext(AppContext);
  const { handoverTicket, loading } = useContext(OfficeTicketDetailContext);
  const [officeTicket, setOfficeTicket] = useState<AxiosResponse<IHandoverTicket, any> | undefined>();
  const location = useLocation();
  const handleCollapseSider = () => {
    setIsDetailSidebarCollapsed(!isDetailSidebarCollapsed);
  };

  useEffect(() => {
    if (location.pathname.includes(urlPath.handoverTicket.location)) {
      setOfficeTicket(handoverTicket);
    }
  }, [location, handoverTicket]);

  const renderConfirmEmployee = (item: IHandoverTicket) => {
    const senderConfirm = item?.handOverTicketConfirms.find(
      (confirm: IConfirm) => confirm.confirmerId === item?.senderId
    );
    const receiverConfirm = item?.handOverTicketConfirms.find(
      (confirm: IConfirm) => confirm.confirmerId === item?.receiverId
    );
    return (
      <Flex vertical gap={10}>
        <Card bordered={false} hoverable>
          <Flex vertical>
            <Text strong>Người bàn giao</Text>
            <Text strong>{item?.senderBy?.fullName || ''}</Text>
            <Text>{item?.senderBy.department?.name}</Text>
            {senderConfirm && (
              <Flex vertical>
                <Tag color='var(--color-approved-request)' style={{ marginTop: '20px', width: 'fit-content' }}>
                  {t('v2.ticketStatus.confirmed')}
                </Tag>
                <Text>{formatDate(senderConfirm.createdDate)}</Text>
              </Flex>
            )}
          </Flex>
        </Card>
        <Card bordered={false} hoverable>
          <Flex vertical>
            <Text strong>Người nhận bàn giao</Text>
            <Text strong>{item?.receiverBy?.fullName || ''}</Text>
            <Text>{item?.receiverBy.department?.name}</Text>
            {receiverConfirm && (
              <Flex vertical>
                <Tag color='var(--color-approved-request)' style={{ marginTop: '20px', width: 'fit-content' }}>
                  {t('v2.ticketStatus.confirmed')}
                </Tag>
                <Text>{formatDate(receiverConfirm.createdDate)}</Text>
              </Flex>
            )}
          </Flex>
        </Card>
      </Flex>
    );
  };

  return (
    <div className='ticket-detail-sidebar'>
      <Flex className='hide-icon' justify='left' onClick={handleCollapseSider}>
        <Icon
          url={isDetailSidebarCollapsed ? LeftIcon : RightIcon}
          size={20}
          titleTooltip={isDetailSidebarCollapsed ? 'Mở cây phê duyệt' : 'Đóng'}
          placementTooltip='bottom'
          open={isDetailSidebarCollapsed && !isTicketDetailCollapsed ? true : false}
        />
      </Flex>
      {!isDetailSidebarCollapsed && (
        <Spin spinning={loading}>
          <Flex justify='center'>
            <Title level={5}>Danh sách xác nhận</Title>
          </Flex>
          {renderConfirmEmployee(officeTicket?.data as IHandoverTicket)}
        </Spin>
      )}
    </div>
  );
}
